import { render, staticRenderFns } from "./MemoriesEditMoment.vue?vue&type=template&id=b1b57cc4"
import script from "./MemoriesEditMoment.vue?vue&type=script&lang=js"
export * from "./MemoriesEditMoment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports